const baseOldQuoteTarget = {
    mode: 'CALL_NEW_QUOTE_AUTO',
    shouldShowPasSelector: false
};

export const categories = [
    {
        id: 'categoria-automovil',
        fontIcon: 'vehiculo_automovil',
        text: 'Automovil',
        mode: 'EMBEDDED',
        route: '/auto-unified',
        shouldShowPasSelector: true
    },
    {
        ...baseOldQuoteTarget,
        id: 'categoria-camion',
        fontIcon: 'vehiculo_camion',
        text: 'Camión',
        categoryKey: 'B'
    },
    {
        ...baseOldQuoteTarget,
        id: 'categoria-acoplado',
        fontIcon: 'vehiculo_acoplado',
        text: 'Acoplado',
        categoryKey: 'C'
    },
    {
        ...baseOldQuoteTarget,
        id: 'categoria-tractor',
        fontIcon: 'vehiculo_tractor',
        text: 'Tractor / Máquina rural',
        categoryKey: 'D'
    },
    {
        ...baseOldQuoteTarget,
        id: 'categoria-moto',
        fontIcon: 'vehiculo_moto',
        text: 'Moto',
        categoryKey: 'E'
    },
    {
        ...baseOldQuoteTarget,
        id: 'categoria-minibus',
        fontIcon: 'vehiculo_minibus',
        text: 'Minibús',
        categoryKey: 'F'
    },
    {
        ...baseOldQuoteTarget,
        id: 'categoria-motorhome',
        fontIcon: 'vehiculo_motorhome',
        text: 'Casa rodante',
        categoryKey: 'G'
    }
];